module.exports = __webpack_public_path__ + "static/media/home_family_doctor_icon.581598d8.png";